import * as React from 'react';
import { select} from 'd3-selection'


import { STATUS_COLORS } from '../../constants'


const MARGIN = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
}


class LiveStatusTimeline extends React.PureComponent {

    constructor(props){
        super(props)
        this.SQUARE_WIDTH = this.props.squareSize || this.props.size[0] - MARGIN.left - MARGIN.right
        this.GAP = this.props.gap || 3
        this.HEIGHT = this.props.size[1] - MARGIN.top - MARGIN.bottom
    }

    componentDidMount(){
        this.createGraph()
    }

    componentDidUpdate(){
        select(this.node).selectAll("g").remove()
        this.createGraph()
    }

    createGraph = () => {

        var svg = select(this.node)
        const hasL0Data = this.props.data && this.props.data.length
        let l0Status = hasL0Data ? "l0 operational" : "No L0 file in last 30 minutes"
        if (hasL0Data && this.props.locationMatch) {
            l0Status = "wrong location"
        }

        const l2Files = this.props.l2Files || []
        const l2Status = l2Files.length ? "L2 file today or yesterday" : "No L2 file today or yesterday"

        const data = [{
            label: l0Status,
            color: STATUS_COLORS[l0Status] || "#919191",
            x: 0
        }, {
            label: l2Status,
            color: l2Files.length ? "#7fcc33" : "#919191",
            x: this.SQUARE_WIDTH + this.GAP
        }]


        var group = svg.append("g")
                    .attr("transform", "translate(" + MARGIN.left + "," + MARGIN.top + ")")



        group.selectAll(".rects").data(data).enter()
            .append("rect")
            .attr("fill", d => d.color)
            .attr("x", d => d.x)
            .attr("width", this.SQUARE_WIDTH)
            .attr("height", this.HEIGHT)
            .append("title").text(d=> d.label)

    }

    render(){



        return(
          <svg ref={node => this.node = node}
          width={this.props.size[0]} height={this.props.size[1]} />
          )
    }
}

export default LiveStatusTimeline;
